
import { currentAppSession } from 'src/utilities/storage';
import { mkCreditEventPayloadForProvider } from '../../Intents/CreditReports/CreditProvideEvent';
import { pathOr } from 'ramda';
import { getBorrowerByRoleId } from 'src/utilities/borrowers';

interface ICreditPullProvider {
  generateCustomData: any;
}

export class CreditPullProvider implements ICreditPullProvider {
  loanRoleId: any;
  loanAppId: any;
  loanRoleAccountId: any;

  constructor() {
    const { loanRoleId, loanAppId, loanRoleAccountId } = currentAppSession();
    this.loanRoleId = loanRoleId;
    this.loanAppId = loanAppId;
    this.loanRoleAccountId = loanRoleAccountId;

  }

  generateCustomData(eventRaw: any, loanApps: any) {
    const customData = pathOr({}, ['customData'], eventRaw);
    const loanType = pathOr('', ['loan_type'], customData);
    const creditProvider = pathOr('', ['credit_provider'], customData);
    const should_run_uw_rule = pathOr('false', ['should_run_uw_rule'], customData);
    const isCoborrower = pathOr('false', ['is_coborrower'], customData);
    const loanApp = pathOr({}, ['spec', 'loanApp'], loanApps);
    const business = pathOr({}, ['spec', 'business'], loanApps);
    const borrowers = pathOr([], ['spec', 'borrowers'], loanApps);
    const lendingTerms = pathOr({}, ['spec', 'lending_terms'], loanApps);
    const borrower = getBorrowerByRoleId(borrowers, this.loanRoleId);

    const payload = mkCreditEventPayloadForProvider(
      loanType,
      creditProvider,
      customData,
      this.loanAppId,
      this.loanRoleId,
      loanApp,
      business,
      should_run_uw_rule,
      borrower,
      this.loanRoleAccountId,
      {
        lendingTerms: [lendingTerms]
      },
      isCoborrower,
      borrowers
    );
    return payload;
  }
}
